import { Utm } from './api/types';

export function readUtm(search: string): Utm {
  const params = new URLSearchParams(search);
  const utm: Utm = {};
  params.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utm[key] = value;
    }
  });
  return utm;
}
